
// const API_BASE_URL = "http://localhost/shreevarma/";  
// const API_BASE_URL = "https://sivakasicrackerscity.com/shreevarma/";
//const API_BASE_URL = "https://ayush.shreevarma.org/api/";
//const API_BASE_URL = "https://aceveda.com/api/";
const API_BASE_URL = "https://aceveda.com/api/";

export default API_BASE_URL;